import React from 'react'
import LoginScreen from '../../pageTemplates/loginScreen'
import ResetPasswordForm from '../../components/forms/resetPasswordForm'

const ResetPassword = () => {
  return (
    <LoginScreen>
  <ResetPasswordForm/>
  </LoginScreen>
  )
}

export default ResetPassword